import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

import { useMobile } from "@krea/customer-features/hooks";
import Button from "@krea/customer-features/shared-components/button";
import { Text } from "@krea/customer-features/shared-components/text";
import { ToastRoot } from "@krea/customer-features/shared-components/toast/ToastRoot";
import { useLoanApplicationFormStore } from "@krea/customer-features/store/loan-application-form/hooks";

export const ApplicationSummary = ({ onReset }) => {
  const isMobile = useMobile();
  const { t } = useTranslation();
  const { organisation, email, mobilePhoneNumber } =
    useLoanApplicationFormStore((store) => ({
      organisation: store.organisation,
      email: store.email,
      mobilePhoneNumber: store.mobilePhoneNumber,
    }));

  const onResetClick = () => {
    if (onReset) {
      onReset();
    }
  };

  const getSummarySteps = () => {
    const steps = [];

    if (organisation?.name) {
      steps.push({
        value: (
          <div>
            <Text htmlTag="div" size="md">
              <span className="font-weight-bold">{organisation?.name}</span>
              {organisation?.organisationNumber
                ? ` (${organisation?.organisationNumber})`
                : ""}
            </Text>
            {mobilePhoneNumber && (
              <Text htmlTag="div" size="sm">
                {mobilePhoneNumber}
              </Text>
            )}
          </div>
        ),
      });
    }

    return steps;
  };

  return (
    <div>
      <div className="mx-6 mx-xl-7">
        <div
          className={classNames("mt-6" + " ", {
            "mx-auto mx-md-8": isMobile,
            "mx-auto col-xl-8": !isMobile,
          })}
        >
          <ToastRoot>
            <div className="align-items-center justify-content-center">
              {getSummarySteps().map((step, index) => (
                <div key={index}>{step.value}</div>
              ))}
            </div>
            <Button onClick={() => onResetClick()} variant="text" className="">
              {t("applicationForm.startOver")}
            </Button>
          </ToastRoot>
        </div>
      </div>
    </div>
  );
};
